import {Card, CardContent, Typography} from "@mui/material";
import {capitalize} from "@mui/material/utils";
import {useTranslation} from "react-i18next";
import {ReactNode} from "react";
import SuspenseBoundary from "../SuspenseBoundary";
import MultipleGuard from "../guards/MultipleGuard";
import {permissions} from "../../permissions";

interface Props {
    children: ReactNode;
}

export default function SectionToolsCard({children}: Props) {
    const {t: translation} = useTranslation("aufgaben");

    return (
        <MultipleGuard permissions={[permissions.tools.list, permissions.tools.show]}>
            <Card variant="outlined">
                <CardContent>
                    <Typography variant="h6">{capitalize(translation("tools-section-title"))}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
                        {translation("tools-section-description")}
                    </Typography>
                    <SuspenseBoundary>
                        {children}
                    </SuspenseBoundary>
                </CardContent>
            </Card>
        </MultipleGuard>
    );
}
